import React from 'react';
import { render } from '@testing-library/react';
import { StatusLight } from './StatusLight';

describe('StatusLight', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<StatusLight data-auto-sel="automation-selector">
				Hello World
			</StatusLight>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
